<template>
  <div class="VideoModel">
    <!-- 视频播放 -->
    <div class="video_model" v-if="isShowVideo"></div>
    <div class="video_con" v-show="isShowVideo">
      <div class="closeVd" @click="OnPaseVideo"></div>
      <div class="video-player">
        <div class="player">
          <video
            controls
            ref="playervideo"
            preload="auto"
            id="playervideo"
            :src="videoSrc"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoModel",
  props: ["isShowVideo", "videoSrc"],
  methods: {
    //播放视频
    OnShowVideo() {
      this.$emit("update:isShowVideo", true);
      this.$refs.playervideo.play();
      //   console.log(v);
    },
    // 暂停视频
    OnPaseVideo() {
      this.$emit("update:isShowVideo", false);
      this.$refs.playervideo.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
.VideoModel {
  position: relative;
  z-index: 1000;
  .video_model {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
  }

  .video_con {
    width: 60%;
    max-height: 80%;
    top: 50%;
    z-index: 1001;
    position: fixed;
    transform: translate(-50%, -50%);
    left: 50%;
    .closeVd {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 0;
      right: -60px;
      z-index: 66;
      cursor: pointer;
      background: url("../../assets/images/common/close.png") no-repeat;
      background-size: 100%;
      &:hover {
        -webkit-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
      -webkit-transition: transform ease-in-out 0.3s;
      -moz-transition: transform ease-in-out 0.3s;
      -ms-transition: transform ease-in-out 0.3s;
      -o-transition: transform ease-in-out 0.3s;
      transition: transform ease-in-out 0.3s;
      -webkit-transform: rotate(0);
      -moz-transform: rotate(0);
      -ms-transform: rotate(0);
      -o-transform: rotate(0);
      transform: rotate(0);
    }
  }

  .video-player {
    width: 100%;
    max-height: 100%;
  }

  .player {
    background: #000;
  }

  .video-player video {
    width: 100%;
    max-height: 800px;
  }
}
</style>